module.exports = __webpack_public_path__ + "static/media/image-pdf.fb378d0a.svg";